"use client";

import { Button } from "@packages/ui/components/button";
import { cn } from "@packages/ui/lib/utils";

export type TaskFilterStatus = "all" | "open" | "claimed" | "completed";

const filters: { value: TaskFilterStatus; label: string }[] = [
	{ value: "all", label: "All" },
	{ value: "open", label: "Open" },
	{ value: "claimed", label: "In Progress" },
	{ value: "completed", label: "Completed" },
];

export function TaskFilters({
	activeFilter,
	onFilterChange,
}: {
	activeFilter: TaskFilterStatus;
	onFilterChange: (filter: TaskFilterStatus) => void;
}) {
	return (
		<div className="flex gap-0.5">
			{filters.map((f) => (
				<Button
					key={f.value}
					variant={activeFilter === f.value ? "secondary" : "ghost"}
					size="sm"
					className={cn(
						"h-9 px-3 text-xs font-medium",
						activeFilter === f.value
							? "text-foreground"
							: "text-muted-foreground",
					)}
					onClick={() => onFilterChange(f.value)}
				>
					{f.label}
				</Button>
			))}
		</div>
	);
}
